<template>
  <nav
    id="topbar"
    class="level px-5 py-2 is-marginless topbar"
    data-test="navbar-desktop-topbar">
    <div class="level-left">
      <breadcrumbs class="level-item"/>
    </div>
    <div class="level-right">
      <div
        v-if="current_profile.type === PROFILE_TYPES.PARTNER"
        v-tooltip.bottom="$t('client.labels.contactZiggu')"
        class="cursor-pointer font-medium relative hover:bg-surface-100 dark:hover:bg-surface-800 rounded-md px-2 py-1" @click="openIntercom">
        {{ $t('client.labels.chatWithUs') }}
      </div>
      <HelpSidebar/>
      <NotificationSidebar v-if="current_profile.type !== PROFILE_TYPES.SUPERVISOR"/>
      <div class="topbar-divider"/>
      <ProfileDropdown #reference/>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import { PROFILE_TYPES } from '@/app/data/model_constants';
import { THEMES } from '@/app/data/themes_constants';
import { ROUTES_EMPLOYEES, ROUTES_PARTNERS } from '@/app/data/route_constants';
import HelpSidebar from '@/app/shared_components/navbar/TheHelpSidebar.vue';
import NotificationSidebar from '@/app/shared_components/navbar/notifications/TheNotificationsSidebar.vue';
import SelectTenant from '@/app/shared_components/SelectTenant.vue';
import ProfileDropdown from './TheProfileDropdown.vue';

export default {
  name: 'TopbarDesktop',
  components: {
    HelpSidebar,
    NotificationSidebar,
    ProfileDropdown,
  },

  data() {
    return {
      PROFILE_TYPES,
      THEMES,
      ROUTES_EMPLOYEES,
      ROUTES_PARTNERS
    };
  },

  computed: {
    ...mapGetters(['current_profile', 'current_profile_true', 'current_is_impersonation']),
  },

  methods: {
    selectTenant() {
      this.$buefy.modal.open({
        component: SelectTenant,
      });
    },
    openIntercom() {
      window.Intercom?.('show');
    }
  },
};
</script>
